import React, {useRef} from "react";
import PopUp from "../base/popup";
import DeletePopup from './deletePopup';
import {Loader} from "react-fields";

export default function UserRow(props) {

    const user = props.user;
    const deleteConfirmationRef = useRef(null);

    const statusName = () => {
       return !user.confirmed_at ? 'Unconfirmed' : 'Confirmed'
    };

    const completeTests = () => {
        let statuses = [user.interests_status,user.personality_status,user.motivators_status,user.abstract_status,
            user.numerical_status,user.verbal_status];
        return !statuses.includes('not_started') && !statuses.includes('started');
    };

    const onDelete = () => {
        deleteConfirmationRef.current.open();
    };

    const deleteUser = () => {
        deleteConfirmationRef.current.close();
        props.onDelete(user.id);
    };

    const linkStyle =  {textDecoration: 'none'};

    return(
        <tr>
            <td><p className="users__primary user__full-line"><a style={linkStyle} href={`/group/users/${user.id}`}>{user.name || 'n/a'}</a></p></td>
            <td><p className="users__secondary"><a style={linkStyle} href={`/group/users/${user.id}`}>{user.email}</a></p></td>
            <td><p className="users__secondary">{statusName()}</p></td>
            {props.full_access || props.interests_access ? <td><p><span className={`small-icon ${!user.temp && user.interests_status === 'finished' ? 'tick-icon' : 'minus-icon--red'}`}/></p></td> : null}
            {props.full_access || props.personality_access ? <td><p><span className={`small-icon ${user.personality_status === 'finished' ? 'tick-icon' : 'minus-icon--red'}`}/></p></td> :null}
            {props.full_access || props.motivators_access ? <td><p><span className={`small-icon ${user.motivators_status === 'finished' ? 'tick-icon' : 'minus-icon--red'}`}/></p></td> : null}
            {props.full_access || props.abstract_access ? <td>{user.abstract_status === 'finished' ? <p className="users__primary">{user.abstract_result}%</p> :
                <p><span className={`small-icon minus-icon--red`}/></p>}
            </td> : null}
            {props.full_access || props.verbal_access ? <td>{user.verbal_status === 'finished' ? <p className="users__primary">{user.verbal_result}%</p> :
                <p><span className={`small-icon minus-icon--red`}/></p>}
            </td> : null}
            {props.full_access || props.numerical_access ? <td>{user.numerical_status === 'finished' ? <p className="users__primary">{user.numerical_result}%</p> :
                <p><span className={`small-icon minus-icon--red`}/></p>}
            </td> : null}
            <td>{user.temp ? <p><span className="trash-icon" title='Delete' onClick={onDelete}/></p> : null}</td>
            <td>{user.temp ? <p><span title='Resend' onClick={() => {props.resend(user)}} className="small-icon envelope-send envelope-send--white"/></p> : null}</td>
            <td><p> <a title='View' href={`/group/users/${user.id}`}><span className="small-icon eye eye--white"/></a></p></td>
            <td><p>{
                completeTests() ? <a title='Download Report' href={`/group/api/users/${user.id}/download_report`}><span
                    className={`small-icon download`}/></a>
                :
                <span className={`small-icon download ${completeTests() ? '' : 'disabled'}`}/>
            }
                </p></td>
            <PopUp ref={deleteConfirmationRef} onClose={() => {}}>
                <DeletePopup email={user.email} onDelete={deleteUser} onCancel={() => {deleteConfirmationRef.current.close()}} />
            </PopUp>
        </tr>
    )

}